/**
 * Welcome to OpsMatrix Tour
 *
 * Introductory tour shown to new users on the dashboard.
 * Walks through the dashboard layout and key quick-action buttons.
 */

import type { TourConfig } from './tour-config.types';

export const welcomeTour: TourConfig = {
  id: 'welcome-to-opsmatrix',
  title: 'tours.welcome.title',
  portal: 'business',
  steps: [
    {
      target: '[data-astor-id="dashboard-metrics-section"]',
      content: 'tours.welcome.steps.dashboardOverview',
      placement: 'bottom',
      route: '/dashboard',
    },
    {
      target: '[data-astor-id="dashboard-new-lead-btn"]',
      content: 'tours.welcome.steps.createLead',
      placement: 'top',
      route: '/dashboard',
    },
    {
      target: '[data-astor-id="dashboard-new-case-btn"]',
      content: 'tours.welcome.steps.createCase',
      placement: 'top',
      route: '/dashboard',
    },
    {
      target: '[data-astor-id="dashboard-upload-doc-btn"]',
      content: 'tours.welcome.steps.uploadDocuments',
      placement: 'top',
      route: '/dashboard',
    },
  ],
};
